import { useEffect, useState } from "react";
import { checkForDuplicateIbans } from "../utils/ibanValidation";

export const useIBANFormValidation = (formValues: any, enableMultipleIBANs: boolean) => {
  const [isFormValid, setIsFormValid] = useState(false);

  useEffect(() => {
    if (enableMultipleIBANs) {
      const hasAtLeastOneIban =
        (formValues.iban1 && formValues.iban1.trim() !== "") ||
        (formValues.iban2 && formValues.iban2.trim() !== "") ||
        (formValues.iban3 && formValues.iban3.trim() !== "");
      const hasDuplicates = checkForDuplicateIbans(formValues);
      setIsFormValid(!!hasAtLeastOneIban && !hasDuplicates);
    } else {
      setIsFormValid(!!formValues.iban && formValues.iban.trim() !== "");
    }
  }, [formValues, enableMultipleIBANs]);

  return isFormValid;
};
